import  { useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
function ResumeForm() {
  const [formData, setFormData] = useState({
    name: '',
    department: '',
    email: '',
    location: '',
    resume: null,
  });
 
  const [uploadProgress, setUploadProgress] = useState(0);
 
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
 
  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    if (!formData.resume) {
      toast.warn("Please upload your resume before submitting.");
      return;
    }
 
    const data = new FormData();
    data.append('name', formData.name);
    data.append('email', formData.email);
    data.append('department', formData.department);
    data.append('location', formData.location);
    data.append('resume', formData.resume);
 
    try {
      toast.info('Uploading resume...');
       await axios.post(
        'http://localhost:5000/api/auth/submit-resume',
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percent);
          },
        }
      );
 
      toast.success('Resume submitted successfully!');
      setFormData({
        name: '',
        department: '',
        email: '',
        location: '',
        resume: null,
      });
      setUploadProgress(0);
      document.getElementById('resume').value = '';
    } catch (err) {
      console.error(err);
      toast.error('Failed to submit resume. Please try again.');
      setUploadProgress(0);
    }
  };
 
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
      <div
  className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5"
  style={{
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
    borderRadius: '15px',
    padding: '20px',
    backgroundColor: '#f8f9fa',
  }}
>
 
          <h2 className="mb-4 fw-bold ">Submit Your Resume</h2>
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="mb-3">
              <label htmlFor="name" className="form-label fw-semibold fs-5">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Your Name"
                required
              />
            </div>
 
            <div className="mb-3">
              <label htmlFor="email" className="form-label fw-semibold fs-5">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Your Email"
                required
              />
            </div>
 
            <div className="mb-3">
              <label htmlFor="department" className="form-label fw-semibold fs-5">
                Department
              </label>
              <input
                type="text"
                className="form-control"
                id="department"
                name="department"
                value={formData.department}
                onChange={handleChange}
                placeholder="Enter Your Department"
                required
              />
            </div>
 
            <div className="mb-3">
              <label htmlFor="location" className="form-label fw-semibold fs-5">
                Applied Location
              </label>
              <input
                type="text"
                className="form-control"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter Your Location"
                required
              />
            </div>
 
            <div className="mb-3">
              <label htmlFor="resume" className="form-label fw-semibold fs-5">
                Resume (PDF/DOC)
              </label>
              <input
                type="file"
                className="form-control"
                id="resume"
                name="resume"
                onChange={handleFileChange}
                required
              />
            </div>
 
            {uploadProgress > 0 && (
              <div className="mb-3">
                <label className="form-label fw-semibold fs-6">Uploading: {uploadProgress}%</label>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${uploadProgress}%` }}
                    aria-valuenow={uploadProgress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {uploadProgress}%
                  </div>
                </div>
              </div>
            )}
 
            <div className="text-center mt-4">
              <button type="submit" className="btn btn-success px-4">
                Submit Resume
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
 
export default ResumeForm;